import { render, staticRenderFns } from "./B2cFinanceIncomeExpenses.vue?vue&type=template&id=4e61b7e4&scoped=true&"
import script from "./B2cFinanceIncomeExpenses.vue?vue&type=script&lang=js&"
export * from "./B2cFinanceIncomeExpenses.vue?vue&type=script&lang=js&"
import style0 from "./B2cFinanceIncomeExpenses.vue?vue&type=style&index=0&id=4e61b7e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e61b7e4",
  null
  
)

export default component.exports